import { PlusOutlined } from '@ant-design/icons'
import { Button, PageHeader } from '@lmc/ui-kit'
import { useAbilityAccess } from 'components/AccessControl'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useResident from 'hooks/useResident'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import AlertList from './components/AlertList'
import AlertModal from './components/AlertModal'
import type { Alert } from './utils/types'

const ResidentAlertsScreen = () => {
  const params = useParams()
  const id = params?.id || ''

  const { resident, isLoading: isResidentLoading } = useResident({ id })

  const flags = useFeatureFlags({ flagNames: ['mods_alerts'] })?.data
  const modsAlertsEnabled = flags?.mods_alerts?.enabled ?? false

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedAlert, setSelectedAlert] = useState<Alert | null>(null)
  const canCreateAlert = useAbilityAccess([{ i: 'create', this: 'Alert' }])

  if (!modsAlertsEnabled) {
    return null
  }

  const pageHeaderTitle =
    isResidentLoading || !resident
      ? 'Alerts'
      : `${resident.name?.first} ${resident.name?.last}'s Alerts`

  const openCreateModal = () => {
    setSelectedAlert(null)
    setIsModalOpen(true)
  }

  const handleEditAlert = (alert: Alert) => {
    setSelectedAlert(alert)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedAlert(null)
  }

  return (
    <>
      <PageHeader title={pageHeaderTitle} sticky>
        <Button
          onClick={openCreateModal}
          variant="primary"
          disabledByPermission={!canCreateAlert}
        >
          <PlusOutlined />
          Add alert
        </Button>
      </PageHeader>
      <AlertList residentId={id} onEditAlert={handleEditAlert} />
      <AlertModal
        open={isModalOpen}
        onClose={handleCloseModal}
        residentId={id}
        initialAlert={selectedAlert}
      />
    </>
  )
}

export default ResidentAlertsScreen
